import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Link } from 'react-router-dom';
import { Menu, Icon, LabelProps } from 'semantic-ui-react';
import userManager from '../userManager';
import MenuUser from './MenuUser';
import { ApplicationState } from '../..';
import * as Core from '../../core';

const connector = connect(
    (state: ApplicationState) => ({
        logo: state.core.auth.user?.profile.picture,
    }),
    Core.actions,
)
type PropsFromRedux = ConnectedProps<typeof connector>

type PrincipaleHeaderDefaultProps = PropsFromRedux

class PrincipaleHeaderDefault extends Component<PrincipaleHeaderDefaultProps> {
    constructor(props: PrincipaleHeaderDefaultProps) {
        super(props);
      
        this.onLogout = this.onLogout.bind(this);
        this.onLinguaClick = this.onLinguaClick.bind(this);
    }

    render () {
      const { logo } = this.props;

      return (
            <Menu attached='top' inverted color='grey'>                
                <Menu.Item>
                    <img src={logo} alt="logo" />
                </Menu.Item>
                <Menu.Item as={Link} to='/contributi'>
                    <Icon name='calendar check' inverted  size='large' />
                    Contributi
                </Menu.Item>
                <Menu.Item as={Link} to='/archiviazione'>
                    <Icon name='file alternate' inverted  size='large' />
                    Archiviazione
                </Menu.Item>
                <MenuUser onLinguaClick={this.onLinguaClick} onLogout={this.onLogout} />
            </Menu>
        );
    }    

    onLogout() {
        userManager.signoutRedirect();
    }

    onLinguaClick(_: React.MouseEvent<HTMLElement, MouseEvent>, data: LabelProps) {
        this.props.cambiaLingua(data.lingua);
    }
}

export default connector(PrincipaleHeaderDefault);
